import VersionsContainer from './versions-container';

export default VersionsContainer;
